import type { MembershipProduct } from "./SpaceType";

/** 零售订阅按钮与购买弹窗共用的可购状态 */
export function membershipRetailPurchaseState(row: MembershipProduct) {
  const isStrategyTool = row.productKind === "strategy_tool";
  const isMarket = isStrategyTool && row.strategySaleMode === "market";
  const pricingMode = row.pricingMode?.trim().toLowerCase() ?? "retail";
  const isRetail = pricingMode === "retail";
  const isNonStandalone = pricingMode === "non_standalone";
  const specs = isRetail ? row.priceSpecs ?? [] : [];
  const overlapBlocked = row.purchaseBlocked === true;
  const canBuyMoreRaw =
    isRetail &&
    (isMarket
      ? (row.strategySkuOffers ?? []).some((o) =>
          (o.priceSpecs ?? []).some((s) => s.enabled)
        )
      : specs.some((s) => s.enabled));
  const canBuyMore = canBuyMoreRaw;
  const canBuyRetail = !row.userSubscribed && canBuyMoreRaw;
  return {
    isStrategyTool,
    isMarket,
    isRetail,
    isNonStandalone,
    specs,
    canBuyMore,
    canBuyRetail,
    overlapBlocked,
    purchaseBlockHint: row.purchaseBlockHint?.trim() || null,
  };
}

/** 是否展示订阅入口并允许进入购买流程（权益重叠 purchaseBlocked 延后在购买确认时校验） */
export function membershipCanEnterRetailPurchase(row: MembershipProduct): boolean {
  const state = membershipRetailPurchaseState(row);
  if (row.userSubscribed) {
    return state.canBuyMore;
  }
  if (state.canBuyRetail) {
    return true;
  }
  if (row.purchaseBlocked !== true) {
    return false;
  }
  if (state.isMarket) {
    return (row.strategySkuOffers ?? []).length > 0;
  }
  if (state.isRetail || state.isStrategyTool || row.productKind === "product_bundle") {
    return (row.priceSpecs ?? []).length > 0;
  }
  return false;
}
